import React, { useState } from "react";
import Box from "react-raster";
import { Heading, List, Paper } from "src/components";
import { theme } from "src/config";
import { Colors } from "src/types";


export const ListSection = () => {
  return (
    <Box>
      <Box gridRowGap={theme.layout.gutterSmall}>
          <Heading
            weight = "normal"
            type   = "h2"
            color  = {Colors.Black}
            text   = "Lists"
          />
          <Box><hr/></Box>
          <List items={['one', 'two', 'three', 'four']} />
      </Box>
    </Box>
  );
}